/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1BannerClassStudentsQueryResponse,
  GetApiV1BannerClassStudentsQueryParams,
  GetApiV1BannerClassStudents401,
  GetApiV1BannerClassStudents500,
} from "../../types/bannerRegistroController/GetApiV1BannerClassStudents.ts";

function getGetApiV1BannerClassStudentsUrl() {
  const res = { method: "GET", url: `/api/v1/banner/class-students` as const };
  return res;
}

/**
 * @description Retorna turmas paginadas (20 por página) filtradas por texto (descrição ou código) e opcionalmente por marca(s). Informe `brandIds` uma ou mais vezes para filtrar por múltiplas marcas (ex: `?brandIds=1&brandIds=2`). Use `activeOnly=true` para restringir apenas às turmas ativas e vigentes (data início ≤ hoje ≤ data fim). **(Requer Authorization para autenticação)**
 * @summary Listar turmas para seleção no banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/class-students}
 */
export async function getApiV1BannerClassStudents(
  params?: GetApiV1BannerClassStudentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1BannerClassStudentsQueryResponse,
    ResponseErrorConfig<
      GetApiV1BannerClassStudents401 | GetApiV1BannerClassStudents500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1BannerClassStudentsUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
